import { getAccountPropertiesAsync } from './getAccountPropertiesAsync'

export const hasActiveAnnualMembershipAsync = async (refresh = false) => {
  const { activeAnnualPass } = await getAccountPropertiesAsync(refresh)

  return !!activeAnnualPass
}
